// Prequalification form


function initializePrequalificationForm() {
  const $prequalificationForm = $('#prequalification-form');

  if ($prequalificationForm) {
    const $questionGroups = $('.prequalification-question-group');
    const $inputs = $prequalificationForm.find('input');
    const $loanTypeInputs = $prequalificationForm.find('input[name="prequalification-LoanType"]');

    const $previousButton = $('#prequalification-button-previous');
    const $nextButton = $('#prequalification-button-next');
    const $progressBar = $('#prequalification-progress-bar');
    const $serverSubmitButton = $('#btnSubmitPrequalificationForm');
    const $disqualifiedModal = $('#prequalification-disqualified-modal');

    const $loadingScreen = $('#prequalification-loading-screen');

    let $availableQuestionGroups;
    let $currentQuestionGroup;

    $previousButton.click(handlePrevious);
    $nextButton.click(handleNext);

    $inputs.keydown(function (e) {
      switch (e.key) {
        case 'Enter':
          e.preventDefault();
          handleNext();
        default:
          return;
      }
    })

    initializeForm();

    // Initializes the prequalification form
    function initializeForm() {
      setAvailableQuestionGroups();
      setCurrentQuestionGroup($availableQuestionGroups.first());
      updateFormNavigation();
    }

    // Handles previous button click
    function handlePrevious() {
      // Reset validity
      resetValidityOnCurrentQuestionGroup();

      // Scroll to the top of the current question group
      $('html, body').animate({
        scrollTop: $currentQuestionGroup.offset().top
      }, 500);

      // Clear current question group answers
      clearQuestionGroup($currentQuestionGroup);

      // Update available question groups
      setAvailableQuestionGroups();

      // Navigate to previous eligible question group
      let index = $availableQuestionGroups.index($currentQuestionGroup);
      setCurrentQuestionGroup($($availableQuestionGroups.get(index - 1)));

      // Set button enabled status
      updateFormNavigation();

      $currentQuestionGroup.find('input').first().focus();
    }

    // Handles next button click
    function handleNext() {
      // Reset validity
      resetValidityOnCurrentQuestionGroup();

      // Scroll to the top of the current question group
      $('html, body').animate({
        scrollTop: $currentQuestionGroup.offset().top
      }, 500);

      // Validate current question group answers
      let isValid = validateCurrentQuestionGroup();

      // Qualify current question group answers
      let isQualified = qualifyCurrentQuestionGroup();

      if (isValid && isQualified) {
        // Update available question groups
        setAvailableQuestionGroups();

        // Navigate to next eligible question group. If this is the last question group, then submit
        let index = $availableQuestionGroups.index($currentQuestionGroup);
        if (index < $availableQuestionGroups.length - 1) {
          setCurrentQuestionGroup($($availableQuestionGroups.get(index + 1)));
          updateFormNavigation();
        } else {
          submitForm();
        }
      }

      $currentQuestionGroup.find('input').first().focus();
    }

    // Clears all inputs on the specified question group
    function clearQuestionGroup($questionGroup) {
      const $textQuestions = $questionGroup.find('input[type="text"],input[type="number"]');
      const $radioQuestions = $questionGroup.find('input[type="radio"]');
      const $labels = $questionGroup.find('label');

      $textQuestions.val('');
      $radioQuestions.prop('checked', false);
      $labels.removeClass('active');
    }

    // Sets available question groups based on loan type
    function setAvailableQuestionGroups() {
      const loanType = $loanTypeInputs.filter(':checked').val();

      if (loanType) {
        $availableQuestionGroups = $questionGroups.filter(`[data-loan-type="All"],[data-loan-type="${loanType}"]`);
      } else {
        $availableQuestionGroups = $($questionGroups);
      }
    }

    // Sets the current question group
    function setCurrentQuestionGroup($questionGroup) {
      if ($currentQuestionGroup) {
        $currentQuestionGroup.removeClass('active');
      }

      $currentQuestionGroup = $questionGroup;
      $currentQuestionGroup.addClass('active');
    }

    // Updates the form navigation
    // Sets previous button disabled status
    // Sets progress bar value
    function updateFormNavigation() {
      const index = $availableQuestionGroups.index($currentQuestionGroup);
      const availableQuestionGroupCount = $availableQuestionGroups.length;

      $previousButton.prop('disabled', index === 0);

      const progressValue = availableQuestionGroupCount !== 0 ? Math.round(100 * index / availableQuestionGroupCount) : 0;
      updateProgressBar(progressValue);
    }

    // Validates the current question group
    // Add invalid class to question group and questions when invalid
    // Returns a value indicating whether the question group is valid
    function validateCurrentQuestionGroup() {
      const $questions = $currentQuestionGroup.find('.prequalification-question');
      let questionGroupIsValid = true;

      // HACK: Make sure toggle buttons active state is consistent with underlying inputs (workaround for toggle buttons improperly handling keyboard events)
      $questions.find('[data-toggle="buttons"] label.active input').prop('checked', true);

      $questions.each(function () {
        const inputs = Array.from(this.querySelectorAll('input'));
        const questionIsValid = inputs.every(i => {
          const $input = $(i);
          if ($input.is('[type="text"]') && $input.data('min-value')) {
            // Validate text fields with custom minimum values (using this approach since not all browsers support type="number" validation)
            const inputValue = parseInt($input.val());
            const minimumValue = parseInt($input.data('min-value'));
            return i.checkValidity() && inputValue >= minimumValue;
          } else {
            return i.checkValidity();
          }
        });

        if (!questionIsValid) {
          questionGroupIsValid = false;

          $(this).addClass('is-invalid');
        }
      });

      if (!questionGroupIsValid) {
        $currentQuestionGroup.addClass('is-invalid');
      }

      return questionGroupIsValid;
    }

    // Qualifies the current question group
    // If disqualified answers were selected, then show disqualified modal with disqualification messages
    // Returns a value indicating whether the question group is qualified
    function qualifyCurrentQuestionGroup() {
      const $selectedDisqualifiedInputs = $currentQuestionGroup.find('input[data-disqualified="true"]:checked');
      const $disqualifiedReasons = $disqualifiedModal.find('.prequalification-disqualified-reasons');

      if ($selectedDisqualifiedInputs.length > 0) {
        $disqualifiedReasons.empty();

        $selectedDisqualifiedInputs.each(function () {
          $('<li>').html($(this).siblings('[data-disqualified-message]').html()).appendTo($disqualifiedReasons);
        });

        $disqualifiedModal.modal('show');

        return false;
      } else {
        return true;
      }
    }

    // Resets validity on current question group
    // Removes invalid class on question group and questions
    function resetValidityOnCurrentQuestionGroup() {
      $currentQuestionGroup.removeClass('is-invalid');
      $currentQuestionGroup.find('.prequalification-question').removeClass('is-invalid');
    }

    // Updates the progress bar with the specified percentage
    function updateProgressBar(progressValue) {
      $progressBar.text(progressValue + '%');
      $progressBar.css('width', progressValue + '%');
      $progressBar.attr('aria-valuenow', progressValue);
      $progressBar.parent('.progress').toggle(progressValue !== 0); // Hide progress on first screen
    }

    // Submits the form and shows the loading screen
    function submitForm() {

      $previousButton.prop('disabled', true);
      $nextButton.prop('disabled', true);

      $questionGroups.removeClass('active');
      $loadingScreen.addClass('active');

      $('html, body').animate({
        scrollTop: $loadingScreen.offset().top
      }, 500);

      updateProgressBar(100);

      submitFormToApi();
    }

    function submitFormToApi() {
      var form = $('#plcPrequalificationForm');
      var formData = form.serialize();
      var url = '/api/prequalification/submit';
        $.ajax({
          type: 'POST',
          url: url,
          data: formData,
          success: function (data) {

            // Ajax call completed successfully
            // alert('Form Submited Successfully');

            var search = window.location.search + (window.location.search ? '&' : '?');
            search += 'pqguid=' + data.itemGuid;
            window.location.href = window.location.protocol + '//' + window.location.host + window.location.pathname + search;
          },
          error: function (data) {

            // Some error in ajax call
            alert('Error submitting data');
          }
        });
    }
  }
}




document.addEventListener('DOMContentLoaded', (event) => {
  initializePrequalificationForm()
})

